import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Activity } from '@vendasta/automata';
import { User } from '@vendasta/iam';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { getFormattedDisplayName } from '../../data-services/users.service';

interface ActivityRow {
  activity: Activity;
  user?: User;
}

@Component({
  selector: 'automata-user-cell',
  template: ` <div class="title">{{ formattedDisplayName }}</div> `,
  styleUrls: ['./user-cell.component.scss'],
  imports: [CommonModule],
})
export class UserCellComponent implements OnInit, CustomCellComponent<ActivityRow> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: ActivityRow;
  @Input() eventEmitter: EventEmitter<any>;
  formattedDisplayName: string;

  ngOnInit(): void {
    this.formattedDisplayName = getFormattedDisplayName(this.element.user);
  }
}
